"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconParcelPlusOutline = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconParcelPlusOutline = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 17.26V6.61l9.3-5.31 9.275 5.312v.803a2.5 2.5 0 0 1 .127.797v3.79h-2.15v-.156h-.127V9.265l-6.998 4.076-7.15-4.175v6.765c0 .035.006.069.018.1l7.46 4.303v2.514l-.02-.012v.064l-8.379-4.792a2.4 2.4 0 0 1-.465-.338L3 17.26Zm13.438-8.951 1.765-1.025-5.622-3.243a.288.288 0 0 0-.154-.048.288.288 0 0 0-.154.048l-1.503.867 5.668 3.4Zm-2.124 1.233L8.64 6.137l-2.116 1.22 5.777 3.354 2.014-1.169Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.24 22.14c.876.876 1.938 1.314 3.187 1.314 1.249 0 2.31-.438 3.186-1.313.876-.876 1.314-1.938 1.314-3.187 0-1.248-.438-2.31-1.314-3.186-.875-.876-1.937-1.314-3.186-1.314-1.249 0-2.31.438-3.186 1.314-.876.875-1.314 1.938-1.314 3.186 0 1.249.438 2.311 1.314 3.187Zm2.656-.292v-2.453H16.35v-1.042h2.546V15.9h1.108v2.453h2.546v1.042h-2.546v2.453h-1.108Z"
}));
exports.IconParcelPlusOutline = IconParcelPlusOutline;
//# sourceMappingURL=IconParcelPlusOutline.js.map